import { createFileRoute } from '@tanstack/react-router';

import { TopicNetworkGraphPage } from '@/features/knowledge-base/TopicNetworkGraphPage';

export const Route = createFileRoute('/_protected/t/$tenantId/knowledge-base/topic/$topicId/graph')({
  component: TopicNetworkGraphRoute,
});

function TopicNetworkGraphRoute() {
  const { topicId } = Route.useParams();

  return <TopicNetworkGraphPage topicId={topicId} />;
}
